/**
 * @generated SignedSource<<03511efa7920470e07892ce3444b3725>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutomationTab_brand$data = {
  readonly appConfig: {
    readonly automatedNotifications: {
      readonly " $fragmentSpreads": FragmentRefs<"AutomatedNotificationsForm_automatedNotifications">;
    };
    readonly id: string;
    readonly postPurchaseOptInEnabled: boolean;
  };
  readonly " $fragmentType": "AutomationTab_brand";
};
export type AutomationTab_brand$key = {
  readonly " $data"?: AutomationTab_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutomationTab_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutomationTab_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postPurchaseOptInEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAutomatedNotificationConnection",
          "kind": "LinkedField",
          "name": "automatedNotifications",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AutomatedNotificationsForm_automatedNotifications"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "3f5d1a569830dfe64f4208ba766904be";

export default node;
